export const mutationType = {
  SET_USER_LOCATION: 'SET_USER_LOCATION',
  SET_PATIENT_LOCATION: 'SET_PATIENT_LOCATION',
}
